import AnniversaryPage from './containers/AnniversaryContainer'

export default store => {
  return {
    path: 'sample-ani',
    exact: true,
    getComponent(nextState, cb) {
      require.ensure([], () => {
        cb(null, AnniversaryPage, 'articles')
      })
    },
  }
}
